// components/Footer.jsx

import React from "react";
import styles from "../styles/Footer.module.css";
import { useNavigate, Link } from "react-router-dom";

export default function Footer() {
  const navigate = useNavigate();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const homeButton = () => {
    if (window.location.pathname === "/") {
      scrollToSection("home");
    } else {
      navigate("/");
    }
  };

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>

        <div>
          <h2>Fegaropetra</h2>
          <p>Unique seafood experience with a perfect seaview.</p>
        </div>

        {/* NAVIGATION (IMPORTANT FIX) */}
        <div>
          <h4>Navigation</h4>

          {/* SPA buttons (keep UX) */}
          <button onClick={homeButton}>Home</button>
          <button onClick={() => scrollToSection("menu")}>Menu</button>
          <button onClick={() => scrollToSection("about")}>About</button>
          <button onClick={() => scrollToSection("gallery")}>Gallery</button>

          {/* CRAWLER LINKS (this is what React Snap needs) */}
          <div style={{ display: "none" }}>
            <a href="/">Home</a>
            <a href="/menu">Menu</a>
            <a href="/about">About</a>
            <a href="/reservation">Reservation</a>
          </div>
        </div>

        <div>
          <h4>Contact</h4>

          <p>+30 2661 043383</p>
          <p>feggaropetraseafood@gmail.com</p>

          <a
            href="https://www.instagram.com/fegaropetra_seafood/"
            target="_blank"
            rel="noreferrer"
            className={styles.link}
          >
            Instagram
          </a>

          <a
            href="https://www.facebook.com/fegaropetra.seafood/"
            target="_blank"
            rel="noreferrer"
            className={styles.link}
          >
            Facebook
          </a>

          {/* Legal routes (already correct) */}
          <Link to="/privacy-policy" className={styles.link}>
            Privacy Policy
          </Link>

          <Link to="/cookie-policy" className={styles.link}>
            Cookie Policy
          </Link>
        </div>
      </div>

      <div className={styles.bottom}>
        © 2026 Mesogeios. Designed and Created by{" "}
        <a
          href="https://cytechsharp.com.cy"
          target="_blank"
          rel="noopener"
          className={styles.creator}
        >
          CyTechSharp
        </a>
      </div>
    </footer>
  );
}